// extracted by mini-css-extract-plugin
module.exports = {"modal-content":"ModalContent_modal-content__QKc_A"};